module.exports = __webpack_public_path__ + "img/direction-1@3x.d06ffe33.png";